import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { Stack } from "@mui/system";
import { useDispatch } from "react-redux";
import SampleReceivedModal from "./SampleReceiveAcknowledge/SampleReceivedModal";
import SampleRejectedModal from "./SampleRejected/SampleRejectedModal";
import { updateBatchState } from "../../../services/FortificationService";
import {
  UpdateLabSamples,
  UpdateLabStates,
  getSpecificSampleDetail,
} from "../../../services/LabService";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment'
import { lengthAndValidCharactersInStringCheck } from "../../../utils/commonFunctions";
import useTranslatewrapper from "../../../components/useTranslateWrapper";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  padding: 1,
};

const SuccessMessageSelector = (status, translate) => {
  switch (status) {
    case "Receive Sample":
      return [translate("Sample Received")];
    case "Submit Test Reports":
      return [translate("Report Submitted")];
    default:
      return [translate(status)];
  }
}

function ActionsModal(props) {
  const {translate} = useTranslatewrapper();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const dispatchShowLoader = (showLoader) => {
    dispatch({
      type: "SHOW_LOADER",
      data: {
        showLoader
      },
    });
  };

  const {
    sampleData,
    testDate,
    type,
    sampleId,
    buttons,
    setStateChange,
    currentCategoryId,
    setActionButtons,
    showButton,
    requestBody,
    sampleTableData,
    sourceCategoryData,
    setDate,
    lastActionDate,
    lastActionDateReject,
  } = props;

  const params = useParams();

  const sessionLabId = sessionStorage.getItem("labId");

  const [openSampleReceivedInLab, setOpenSampleReceivedInLab] =
    React.useState(false);
  const [fileUploadValidated, setFileUploadValidated] = useState(false);
  const [tableDataValidated, setTableDataValidated] = useState(false);
  const [errorArray, setErrorArray] = useState([]);

  const handleOpenSampleReceivedInLab = () => setOpenSampleReceivedInLab(true);
  const handleCloseSampleReceivedInLab = () =>
    setOpenSampleReceivedInLab(false);
  const OnSampleReceivedInLabSubmit = (value) => {
    setOpenSampleReceivedInLab(value);
  };

  const [openSampleRejected, setOpenSampleRejected] = React.useState(false);
  const handleOpenSampleRejected = () => setOpenSampleRejected(true);
  const handleCloseSampleRejected = () => setOpenSampleRejected(false);
  const OnSampleRejectedSubmit = (value) => {
    setOpenSampleRejected(value);
  };

  const [openSampleLabTestDone, setOpenSampleLabTestDone] =
    React.useState(false);
  const handleOpenSampleLabTestDone = () => setOpenSampleLabTestDone(true);
  const handleCloseSampleLabTestDone = () => setOpenSampleLabTestDone(false);
  const OnSampleLabTestDoneSubmit = (value) => {
    setOpenSampleLabTestDone(value);
  };

  const [currentButtonClicked, setCurrentButtonClicked] = React.useState("");
  const [currentAction, setCurrentAction] = React.useState("");

  const StateUpdate = {
    comments: null,
    dateOfAction: new Date(),
    isInspectionSample: sampleData.isInspectionSample
  };

  let arrVal = [];
  const labTestTableValidation = () => {
    const nonEmptyResult = sampleTableData.some(obj => obj.result != "")

    if((sampleTableData.length === 0) || !nonEmptyResult){ 
      arrVal.push({
        name: translate('labTestDetails'),
        value: translate('addAtLeastOneTestWithResult'),
        isFullMessage: true,
        translate: true

      });
      return false;
    }




    sampleTableData.map((item) => {
        if (!item.name || item.name === "") {
          arrVal.push({
            name: item.name,
            value: "Test Name",
          });
        }
        else{
          let validationResult =  lengthAndValidCharactersInStringCheck(item.name)
          if(!validationResult['status']){
            // arrErr.push("comments" +": "+ validationResult['message'])
            arrVal.push({
              name: "Test Name",
              value: validationResult['message'],
              isFullMessage: true
            });
          }
        }
        if(item.testMethodFollowed){
          let validationResult =  lengthAndValidCharactersInStringCheck(item.testMethodFollowed)
          if(!validationResult['status']){
            // arrErr.push("comments" +": "+ validationResult['message'])
            arrVal.push({
              name: "Test Method Followed",
              value: validationResult['message'],
              isFullMessage: true

            });
          }
        }
        if (
          item.selectionList.length >0 && item.selectionList?.filter((elem) => item?.reference === elem.name)[0]
            .labTestType.isMandatory
        ) {
        if (!item.result || item.result?.trim() === "") {
          arrVal.push({
            name: item.name,
            value: "Result",
          });
        }

        if(item.result && !isNaN(parseFloat(item.result.trim())) && parseFloat(item.result.trim()) <0){
          arrVal.push({
            name: item.name,
            value: "Result Invalid",
          });
        }
        // if (!item.testMethodFollowed || item.testMethodFollowed === "") {
        //   arrVal.push({
        //     name: item.name,
        //     value: "Test Method Followed",
        //   });
        // }
      }
    });

    if (arrVal.length === 0) {
      setTableDataValidated(true);
      return true;
    } else {
      setTableDataValidated(false);
      return false;
    }
  };

  let arrId = [];
  let newArr;
  const fileUploadValidation = () => {
    
    requestBody.sampleTestDocuments.map((data) => {
      if (!data.categoryDocId && (!data.name || (data.name === ""))) {
        arrId.push({
          name: "Test name",
          value: false,
        });
      }
      // if(!data.categoryDocId && data.name && data.name !== ""){
      //   let validationResult =  lengthAndValidCharactersInStringCheck(data.name)
      //   if(!validationResult['status']){
      //     // arrErr.push("comments" +": "+ validationResult['message'])
      //     arrId.push({
      //       name: "Test name",
      //       message: validationResult['message'],
      //       value: false,
      //       isFullMessage: true

      //     });
      //   }
      // }
      if (!data.categoryDocId && (data.path === "")) {
        arrId.push({
          name: "File upload",
          value: false,
        });
      }
    })
    sourceCategoryData?.categoryDocumentRequirements?.map((data) => {
      if (data.isMandatory) {
        
        if (
          requestBody.sampleTestDocuments.findIndex(
            (elem) => 
              (data.id === elem.categoryDocId) && (elem.path !== "")
          ) !== -1
        ) {
          arrId.push({
            name: data.docType.name,
            value: true,
          });
        } else {
          arrId.push({
            name: data.docType.name?.toLowerCase() === 'lab report' ? translate('lab report') : data.docType.name,
            value: false,
          });
        }
      }
    });

    newArr = arrId.filter((ele) => ele.value === false);

    if (arrId.length === 0 || newArr.length === 0) {
      setFileUploadValidated(true);
      return true;
    } else {
      setFileUploadValidated(false);
      return false;
    }
  };

  const validateFunction = () => {
    if (!fileUploadValidation()) {
      newArr.map((ele) => ele.isFullMessage ? errorArray.push(`${ele.name} : ${ele.message}`) : errorArray.push(`${ele.name} ${translate('isNotSelected')}`));
    }
    if (!requestBody.testDate) {
      errorArray.push(translate('testDateIsNotSelected'));
    }
    if (
      new Date(sampleData?.receivedDate?.slice(0, 10)) >
      new Date(requestBody.testDate)
    ) {
      errorArray.push("Test date cannot be before Sample Received date");
    }
    if (new Date(requestBody.testDate) > new Date(moment.utc().local().format('YYYY-MM-DD'))) {
      errorArray.push(" Test date cannot be greater than Current date");
    }
    if (!requestBody.performedBy || requestBody.performedBy?.trim() === "") {
      errorArray.push(translate('performedByIsNotSelected'));
    } else{
      let validationResult =  lengthAndValidCharactersInStringCheck(requestBody.performedBy)
      if(!validationResult['status']){
        // arrErr.push("comments" +": "+ validationResult['message'])
        errorArray.push("Performed by" +": "+ validationResult['message']);
      }
    }



    if (!labTestTableValidation()) {//
      arrVal.map((ele) => (
        (ele.value == "Result Invalid") ? errorArray.push(`${ele.name} : Result cannot be negative`) : 
        ele.isFullMessage ? errorArray.push(`${ele.name} : ${ele.value}`) :
        errorArray.push(`${ele.name} : ${ele.value} ${translate('isNotSelected')}`)
      )
      );
    }
    let msg = "";
    errorArray.map((err) => (msg += err + "\n"));
    if (errorArray.length > 0) {
      dispatchNotification("error", errorArray);
    } else {
      handleOpenSampleLabTestDone();
    }
  };

  const handleLabSampleTestDone = async (action, actionText, formData) => {
    const message = SuccessMessageSelector(actionText, translate);
    dispatchShowLoader(true)
    StateUpdate["stateId"] = buttons?.find(
      (element) => element.name === action || element.name === currentAction
    )?.id;
    StateUpdate.comments = formData?.comments || "";
    StateUpdate.dateOfAction = moment(formData?.SampleReceivedAtLabDate.toString()).format('yyyy-MM-DD');

    sampleData.batchId && (StateUpdate["batchId"] = Number(sampleData.batchId));
    sampleData.lotId && (StateUpdate["lotId"] = Number(sampleData.lotId));
    const LabUpdateResponse = await UpdateLabStates(
      sessionLabId,
      sampleId,
      actionText,
      moment(formData?.SampleReceivedAtLabDate.toString()).format('yyyy-MM-DD'),
      params.categoryId
    );
    if (LabUpdateResponse?.status === 200) {
      dispatchNotification("success", message);
      setDate(moment(formData?.SampleReceivedAtLabDate.toString()).format('yyyy-MM-DD'));    
    }
    if ( LabUpdateResponse?.status === 200){
      if(!sampleData.isInspectionSample){
        const result = await updateBatchState(
          currentCategoryId,
          type,
          sampleData?.batchId || sampleData?.lotId,
          StateUpdate,
          ""
          );
          if (result.status === 200) {
            dispatchNotification("success", message);
            setActionButtons(
              sampleData?.batchId || sampleData?.lotId,
              sampleData?.batchId ? "batch" : "lot",
              true,
              ""
              );
            }
      }else{
        const data = await getSpecificSampleDetail(sampleId);
        setActionButtons(
          sampleData?.batchId || sampleData?.lotId,
          sampleData?.batchId ? "batch" : "lot",
          true,
          data.data?.state.name || ""
        );
        }
      }
      
    dispatchShowLoader(false);
    
  };

  const handleFormSubmit = async (action, actionText, formData) => {
    const message = SuccessMessageSelector(actionText, translate);
    dispatchShowLoader(true)
    StateUpdate["stateId"] = buttons?.find(
      (element) => element.name === action || element.name === currentAction
    )?.id;
    StateUpdate.comments = formData?.comments || "";

    StateUpdate.dateOfAction =
      requestBody.testDate || moment(formData?.SampleReceivedAtLabDate.toString()).format('yyyy-MM-DD');

    sampleData.batchId && (StateUpdate["batchId"] = Number(sampleData.batchId));
    sampleData.lotId && (StateUpdate["lotId"] = Number(sampleData.lotId));

    
    // requestBody.receivedDate = formData?.SampleReceivedAtLabDate;
    const response = await UpdateLabSamples(sampleId, requestBody, (data)=>dispatchNotification('error', [data.response.data.message]));

    if (response?.status == 200) {
      const LabUpdateResponse = await UpdateLabStates(
        sessionLabId,
        sampleId,
        actionText,
        requestBody.testDate,
        params.categoryId
      );
    if (LabUpdateResponse?.status === 200) {
        dispatchNotification("success", message);
        StateUpdate['labId'] = response.data.labId || 0; 
        const result = await updateBatchState(
          currentCategoryId,
          type,
          sampleData?.batchId || sampleData?.lotId,
          StateUpdate,
          response.data.labSampleResult,
          response.data.isExternalTest
        );
        if (result.status === 200) {
          const data = await getSpecificSampleDetail(sampleId);
          dispatchNotification("success", message);
          if(sampleData.isInspectionSample){
            if(data?.data){
              setActionButtons(
                sampleData?.batchId || sampleData?.lotId,
                sampleData?.batchId ? "batch" : "lot",
                true,
                data?.data?.state.name || ""
              );
            }
          }
          setActionButtons(
            sampleData?.batchId || sampleData?.lotId,
            sampleData?.batchId ? "batch" : "lot",
            true,
            ""
          );
        }
      }
      // const result = await updateBatchState(
      //   currentCategoryId,
      //   type,
      //   sampleData?.batchId || sampleData?.lotId,
      //   StateUpdate,
      //   response.data
      // );
      // if (result.status === 200) {
      //   dispatchNotification("success", [actionText]);
      // }
    }else{
      handleCloseSampleLabTestDone()
      dispatchShowLoader(false);
      setOpenSampleLabTestDone()
    }
    dispatchShowLoader(false);
  };

  const clickHandler = (action, actionText) => {
    setCurrentAction(action);
    if (action === "batchSampleInLab" || action === "lotSampleInLab") {
      setCurrentButtonClicked(actionText);
      handleOpenSampleReceivedInLab();
    } else if (
      action === "batchSampleLabTestDone" ||
      action === "lotSampleLabTestDone"
    ) {
      setCurrentButtonClicked(actionText);
      validateFunction();
      setErrorArray([]);
    } else if (
      action === "batchSampleRejected" ||
      action === "lotSampleRejected"
    ) {
      setCurrentButtonClicked(actionText);
      handleOpenSampleRejected();
    }
  };
  const sendFormData = async () => {
    const response = await UpdateLabSamples(sampleId, requestBody);
  };
  return (
    <Box>
    {sampleData?.state?.name != "rejected" &&
      <Stack spacing={1} direction="row">
        {buttons?.map((element, index) => (
          <Button
            variant="contained"
            key={element.actionName}
            onClick={() => clickHandler(element.name, element.actionName)}
          >
            {translate(element.actionName.toLowerCase())}
          </Button>
        ))}
      </Stack>
    }
      <Modal
        open={openSampleReceivedInLab}
        onClose={handleCloseSampleReceivedInLab}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <SampleReceivedModal
            handleClose={OnSampleReceivedInLabSubmit}
            name={currentAction}
            sampleData={sampleData}
            action={buttons}
            buttonText={currentButtonClicked}
            setStateChange={setStateChange}
            currentCategoryId={currentCategoryId}
            handleLabSampleTestDone={handleLabSampleTestDone}
            lastActionDate={lastActionDate}
          />
        </Box>
      </Modal>
      <Modal
        open={openSampleRejected}
        onClose={handleCloseSampleRejected}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <SampleRejectedModal
            handleClose={OnSampleRejectedSubmit}
            name={currentAction}
            sampleData={sampleData}
            action={buttons}
            buttonText={currentButtonClicked}
            setStateChange={setStateChange}
            currentCategoryId={currentCategoryId}
            handleLabSampleTestDone={handleLabSampleTestDone}
            lastActionDate={lastActionDateReject}
          />
        </Box>
      </Modal>

      <Box>
        <div className="modalForm">
          <Dialog
            open={openSampleLabTestDone}
            onClose={handleCloseSampleLabTestDone}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {translate('confirmationMsg')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {translate('confirmMarkSampleAsTestDone')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseSampleLabTestDone}
                variant="contained"
              >
                {translate('no')}
              </Button>
              <Button
                type="submit"
                variant="contained"
                onClick={() => {
                  handleFormSubmit("", currentButtonClicked, {});
                }}
                autoFocus
              >
                {translate('yes')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>
    </Box>
  );
}

export default ActionsModal;
